import template from './lookup-field.html';

const LookupFieldComponent = {
    bindings: {
        errorMessage: '<',
        hideLabel: '<',
        inputClass: '<',
        label: '<',
        labelClass: '<',
        lookupProperty: '<',
        value: '=',
        options: '<'
    },
    template
};

export default LookupFieldComponent;



// WEBPACK FOOTER //
// ./app/common/form-fields/lookup-field/lookup-field-component.js